const isDevelopment = process.env.NODE_ENV === 'development';
const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8080/api'
  : 'https://api.navalprabhakar.windsurf.build/api';

export const API_ENDPOINTS = {
  RESUME: `${API_BASE_URL}/resume`,
  ARTICLES: `${API_BASE_URL}/articles`,
  VIDEOS: `${API_BASE_URL}/videos`,
};
